/* oxlint-disable react-hooks-js/immutability */
/* eslint-disable react-hooks/immutability */

import { useTranslation } from '@mint-lib/i18n';
import { InputHelperText } from '@mint-lib/tw-components';
import { Counter } from '@mint-lib/tw-components/patterns';
import { useSnapshot } from 'valtio';

import { Switch } from '../../atoms/index.js';
import type { TemplateDuplicationFormState } from './types.js';

type FooterRowsControlProps = {
  state: TemplateDuplicationFormState;
};

export const FooterRowsControl = ({ state }: FooterRowsControlProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const snap = useSnapshot(state);

  const isFooterWarningActive =
    snap.ui.isFooterRowsEnabled && snap.form.footerRowsCount === 0;

  const handleFooterRowsEnabledChange = (checked: boolean) => {
    state.ui.isFooterRowsEnabled = checked;
    if (!checked) {
      state.form.footerRowsCount = 0;
    }
  };

  return (
    <div className="ml-auto flex max-w-[186px] flex-[0_1_fit-content] flex-col">
      <Switch
        className="mb-1"
        label={t('Remove footer row(s)')}
        infoIconWithTooltip={t(
          'Number of footer rows to be automatically discarded during import.',
        )}
        checked={snap.ui.isFooterRowsEnabled}
        onCheckedChange={handleFooterRowsEnabledChange}
        size="small"
      />
      <Counter
        value={snap.form.footerRowsCount}
        onChange={(value) => {
          state.form.footerRowsCount = value;
        }}
        min={0}
        max={40}
        disabled={!snap.ui.isFooterRowsEnabled}
        size="medium"
        color={isFooterWarningActive ? 'warning' : 'default'}
      />
      {isFooterWarningActive && (
        <InputHelperText helperText={t('No rows selected')} color="warning" />
      )}
    </div>
  );
};
